import React, { useCallback, useEffect, useState } from "react";
import "./App.css";
import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";
import { fetchIpAddress } from "./controllers/API"

import GeneralData from "./pages/CMS/GeneralData/StoreDetailsForm.js";
import FAQ from "./pages/CMS/Faq/List.js";
import AddEditFAQ from "./pages/CMS/Faq/AddEditData.js";
import Partners from "./pages/CMS/Partners/List.js";
import AddEditPartners from "./pages/CMS/Partners/addEditData.js";
import Teams from "./pages/CMS/Teams/List.js";
import AddEditTeams from "./pages/CMS/Teams/addEditData.js";
import Advisory from "./pages/CMS/Advisory/List.js";
import AddEditAdvisory from "./pages/CMS/Advisory/addEditData.js";
import Gallery from "./pages/CMS/Gallery/List.js";
import AddEditGallery from "./pages/CMS/Gallery/addEditData.js";
import KcAlbum from "./pages/CMS/Album/List.js";
import AddeditKcAlbum from "./pages/CMS/Album/addEditData.js";
import Articles from "./pages/CMS/Articles/List.js";
import AddeditArticles from "./pages/CMS/Articles/addEditData.js";
import AtKCPublications from "./pages/AtKC/Publications/Publications.js";
import FeaturesList from "./pages/CMS/Cms_Content/List.js";
import AddEditFeaturesList from "./pages/CMS/Cms_Content/addEditData.js"; 

import StatsList from "./pages/CMS/Cms_Content/StatsList.js";
import AddEditStatsList from "./pages/CMS/Cms_Content/StatsAddEdit.js";

import AboutFounder from "./pages/CMS/Founder/List.js";
import EditAboutFounder from "./pages/CMS/Founder/AddEditData.js";

import FounderJourneyList from "./pages/CMS/Cms_Content/FdJourneyList.js";
import FounderJourney from "./pages/CMS/Cms_Content/FdJourneyAddEdit.js";

import Academics from "./pages/Academics/Academics/List.js";
import AddEditAcademics from "./pages/Academics/Academics/addEditData.js";
import AcademicsBanner from "./pages/Academics/Banners/List.js";
import AddEditAcademicsBanner from "./pages/Academics/Banners/addEditData.js";
import AcademicsStages from "./pages/Academics/Stages/List.js";
import AddEditAcademicsStages from "./pages/Academics/Stages/addEditData.js";
import AcademicsDomains from "./pages/Academics/Domains/List.js";
import AddEditAcademicsDomains from "./pages/Academics/Domains/addEditData.js";
import AcademicsCurriculums from "./pages/Academics/Curriculums/List.js";
import AddEditAcademicsCurriculums from "./pages/Academics/Curriculums/addEditData.js";

import ContactsList from "./pages/Submissions/ContactsList.js";
import ReviewsList from "./pages/Submissions/ReviewsList.js"; //new 
import PolicyList from "./pages/Policies/List.js";
import AddEditPolicyList from "./pages/Policies/addEditData.js";

import CareerList from "./pages/Careers/List.js";
import AddEditCareerList from "./pages/Careers/addEditData.js";

import CareerAplliedList from "./pages/Submissions/JobApplicationList.js";

import RegistrationsList from "./pages/Submissions/RegistrationsList.js";
import AddEditRegistrationsList from "./pages/Submissions/addEditRegistartion.js";


import ApCoursesList from "./pages/Apcourses/List.js";
import AddEditApCoursesList from "./pages/Apcourses/addEditData.js";

import AdmissionProcessList from "./pages/AdmissionProcess/List.js";
import AddEditAdmissionProcessList from "./pages/AdmissionProcess/addEditData.js";

import CampusesList from "./pages/CMS/Campuses/List.js";
import AddEditCampusesList from "./pages/CMS/Campuses/addEditData.js";

import RoadmapList from "./pages/CMS/Roadmap/RoadmapList.js";
import AddEditRoadmap from "./pages/CMS/Roadmap/RoadMapAddEdit.js";

import HomeBanner from "./pages/CMS/HomeBanner/List.js";
import AddEditHomeBanner from "./pages/CMS/HomeBanner/addEditData.js";

import ChildPotentialList from "./pages/CMS/Cms_Content/ChildPotentialList.js";
import ChildPotential from "./pages/CMS/Cms_Content/ChildPotentialAddEdit.js";

import QuickConnectList from "./pages/CMS/Cms_Content/QuickconnectList.js";
import QuickConnectAddEdit from "./pages/CMS/Cms_Content/QuickconnectAddEdit.js";

import HomeBannerImgList from "./pages/CMS/Cms_Content/HomebannerimgList.js";
import HomeBannerImgAddEdit from "./pages/CMS/Cms_Content/HomebannerimgAddedit.js";

import EmailList from "./pages/EmailTemplates/List.js";
import AddEditEmail from "./pages/EmailTemplates/addEditData.js";

import APexams from "./pages/Apexams/List.js";
import AddEditAPexams from "./pages/Apexams/addEditData.js";

import Satexams from "./pages/Satexams/List.js";
import AddEditSatexams from "./pages/Satexams/addEditData.js";

import AdmissionPrograms from "./pages/CMS/AdmissionPrograms/List.js";
import AddEditAdmissionPrograms from "./pages/CMS/AdmissionPrograms/AddEditData.js";
import axios from "axios";
import { useInactivityTimeout, useSessionCheck } from "./controllers/sessionUser.js";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { fetchUserInfo } = useUserStore();

  const getIp = async () => {
    await fetchIpAddress();
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = sessionStorage.getItem("TOKEN");
    const isSessionActive = sessionStorage.getItem("session") === "true"
      if (!["/", "/reset-password"].includes(location?.pathname)) {
        if (!token) {
          if(isSessionActive){
            navigate('/', { state: "Session expired! Please re-login." });
          }else
          navigate("/");
        } else {
          // fetchUserInfo();
        }
      }
    };

    checkAuthentication();
  }, [location, navigate]);

  // Check Session Expire & Session In
  const authToken = sessionStorage.getItem('TOKEN');

  useSessionCheck(authToken);
  // useInactivityTimeout(600000, () => {
  //   sessionStorage.removeItem('authToken');
  //   navigate('/');
  //   alert('You have been logged out due to inactivity.');
  // });


  return (
    <div className="App">

        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={ <Sidebar> <Dashboard /> </Sidebar> } />

          <Route path="/cms/general-data" element={ <Sidebar> <GeneralData /> </Sidebar> } />

          <Route path="/cms/faq" element={ <Sidebar> <FAQ /> </Sidebar> } />
          <Route path="/cms/faq/addeditdata" element={ <Sidebar> <AddEditFAQ /> </Sidebar> } />

          <Route path="/cms/partners" element={ <Sidebar> <Partners /> </Sidebar> } />
          <Route path="/cms/partners/addeditdata" element={ <Sidebar> <AddEditPartners /> </Sidebar> } />

          <Route path="/cms/team" element={ <Sidebar> <Teams /> </Sidebar> } />
          <Route path="/cms/team/addeditdata" element={ <Sidebar> <AddEditTeams /> </Sidebar> } />

          <Route path="/cms/advisory" element={ <Sidebar> <Advisory /> </Sidebar> } />
          <Route path="/cms/advisory/addeditdata" element={ <Sidebar> <AddEditAdvisory /> </Sidebar> } />

          <Route path="/cms/gallery" element={ <Sidebar> <Gallery /> </Sidebar> } />
          <Route path="/cms/gallery/addeditdata" element={ <Sidebar> <AddEditGallery /> </Sidebar> } />

          <Route path="/cms/album" element={ <Sidebar> <KcAlbum /> </Sidebar> } />
          <Route path="/cms/album/addeditdata" element={ <Sidebar> <AddeditKcAlbum /> </Sidebar> } />

          <Route path="/cms/articles" element={ <Sidebar> <Articles /> </Sidebar> } />
          <Route path="/cms/articles/addeditdata" element={ <Sidebar> <AddeditArticles /> </Sidebar> } />
          <Route path="/at-kc/publications" element={ <Sidebar> <AtKCPublications /> </Sidebar> } />

          <Route path="/cms/features" element={ <Sidebar> <FeaturesList /> </Sidebar> } />
          <Route path="/cms/features/addeditdata" element={ <Sidebar> <AddEditFeaturesList /> </Sidebar> } />

          <Route path="/cms/stats" element={ <Sidebar> <StatsList /> </Sidebar> } /> 
          <Route path="/cms/stats/addeditdata" element={ <Sidebar> <AddEditStatsList /> </Sidebar> } />

          <Route path="/cms/founder" element={ <Sidebar> <AboutFounder /> </Sidebar> } />
          <Route path="/cms/founder/addeditdata" element={ <Sidebar> <EditAboutFounder /> </Sidebar> } />

          <Route path="/cms/founder-journey" element={ <Sidebar> <FounderJourneyList/> </Sidebar> } /> 
          <Route path="/cms/founder-journey/addeditdata" element={ <Sidebar> <FounderJourney /> </Sidebar> } />

          <Route path="/academics" element={ <Sidebar> <Academics /> </Sidebar> } />
          <Route path="/academics/addeditdata" element={ <Sidebar> <AddEditAcademics /> </Sidebar> } />

          <Route path="/academic/banners" element={ <Sidebar> <AcademicsBanner/> </Sidebar> } />
          <Route path="/academic/banners/addeditdata" element={ <Sidebar> <AddEditAcademicsBanner/> </Sidebar> } />
          
          <Route path="/academic/stages" element={ <Sidebar> <AcademicsStages/> </Sidebar> } />
          <Route path="/academic/stages/addeditdata" element={ <Sidebar> <AddEditAcademicsStages/> </Sidebar> } />
          
          <Route path="/academic/domains" element={ <Sidebar> <AcademicsDomains/> </Sidebar> } />
          <Route path="/academic/domains/addeditdata" element={ <Sidebar> <AddEditAcademicsDomains/> </Sidebar> } />
          
          <Route path="/academic/curriculums" element={ <Sidebar> <AcademicsCurriculums/> </Sidebar> } />
          <Route path="/academic/curriculums/addeditdata" element={ <Sidebar> <AddEditAcademicsCurriculums/> </Sidebar> } />

          <Route path="/contacts" element={ <Sidebar> <ContactsList/> </Sidebar> } /> 
          <Route path="/job-applications" element={ <Sidebar> <CareerAplliedList/> </Sidebar> } />
          <Route path="/site-reviews" element={ <Sidebar> <ReviewsList/> </Sidebar> } />
          
          <Route path="/policies" element={ <Sidebar> <PolicyList/> </Sidebar> } />          
          <Route path="/policies/addeditdata" element={ <Sidebar> <AddEditPolicyList/> </Sidebar> } />

          <Route path="/careers" element={ <Sidebar> <CareerList/> </Sidebar> } />          
          <Route path="/careers/addeditdata" element={ <Sidebar> <AddEditCareerList/> </Sidebar> } />

          <Route path="/registrations" element={ <Sidebar> <RegistrationsList/> </Sidebar> } />
          <Route path="/registration/addeditdata" element={ <Sidebar> <AddEditRegistrationsList/> </Sidebar> } />

          <Route path="/ap-courses" element={ <Sidebar> <ApCoursesList/> </Sidebar> } />          
          <Route path="/ap-courses/addeditdata" element={ <Sidebar> <AddEditApCoursesList/> </Sidebar> } />

          <Route path="/admission-process" element={ <Sidebar> <AdmissionProcessList/> </Sidebar> } />          
          <Route path="/admission-process/addeditdata" element={ <Sidebar> <AddEditAdmissionProcessList/> </Sidebar> } /> 

          <Route path="cms/campuses" element={ <Sidebar> <CampusesList/> </Sidebar> } />          
          <Route path="cms/campuses/addeditdata" element={ <Sidebar> <AddEditCampusesList/> </Sidebar> } />

          <Route path="cms/roadmap" element={<Sidebar> <RoadmapList/> </Sidebar>} />
          <Route path="cms/roadmap/addeditdata" element={<Sidebar> <AddEditRoadmap/> </Sidebar>} />

          <Route path="cms/home-banner" element={<Sidebar> <HomeBanner/> </Sidebar>} />
          <Route path="cms/home-banner/addeditdata" element={<Sidebar> <AddEditHomeBanner/> </Sidebar>} />

          <Route path="/cms/child-potential" element={ <Sidebar> <ChildPotentialList/> </Sidebar> } /> 
          <Route path="/cms/child-potential/addeditdata" element={ <Sidebar> <ChildPotential /> </Sidebar> } />

          <Route path="/cms/quick-connect" element={<Sidebar><QuickConnectList/></Sidebar>} />
          <Route path="/cms/quick-connect/addeditdata" element={<Sidebar><QuickConnectAddEdit/></Sidebar>} /> 

          <Route path="/cms/home-banner-images" element={<Sidebar><HomeBannerImgList/></Sidebar>} />
          <Route path="/cms/home-banner-images/addeditdata" element={<Sidebar><HomeBannerImgAddEdit/></Sidebar>} />

          <Route path="/ap-exams" element={ <Sidebar> <APexams/> </Sidebar> } /> 
          <Route path="/ap-exams/addeditdata" element={ <Sidebar> <AddEditAPexams/> </Sidebar> } /> 

          
          <Route path="/sat-exams" element={ <Sidebar> <Satexams/> </Sidebar> } /> 
          <Route path="/sat-exams/addeditdata" element={ <Sidebar> <AddEditSatexams/> </Sidebar> } />

          <Route path="/email-templates" element={ <Sidebar> <EmailList/> </Sidebar> } />          
          <Route path="/email-templates/addeditdata" element={ <Sidebar> <AddEditEmail/> </Sidebar> } />

          <Route path="/cms/admission-programs" element={ <Sidebar> <AdmissionPrograms/> </Sidebar> } />          
          <Route path="/cms/admission-programs/addeditdata" element={ <Sidebar> <AddEditAdmissionPrograms/> </Sidebar> } />

        </Routes>
    </div>
  );
};

export default App;
